import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';

@Component({
	selector: 'xp-column-header',
	standalone: true,
	imports: [MatSortModule],
	templateUrl: './xp-column-header.component.html',
	styleUrls: ['./xp-column-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpColumnHeaderComponent {
	heading = input('');
	sortDisabled = input(false);
}
